import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const governmentValidationState = atom<boolean>({
  key: 'governmentState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
